module.exports = __webpack_public_path__ + "static/media/5f8de7ec5ae7590275f07473_logo_200x200.a4274d49.png";